import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { filter, concatMap, withLatestFrom } from 'rxjs/operators';
import { LocationChangeAction, LOCATION_CHANGE } from 'connected-react-router';
import AppState from '../../state';
import { NoOp, OpenMenu } from '../../ui/action-creators';
import { ClearNotifications } from '../action-creators';
import { SetPopupNotification } from '../action-creators';
import { ReleaseAcceptedPayload } from '@common/types/notifications/payloads/release-accepted-payload';

export const showReleaseApprovedEpic = (
  action$: Observable<LocationChangeAction>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<LocationChangeAction>(LOCATION_CHANGE),
    withLatestFrom(state$),
    filter(([, state]) => state.notifications.notificationLoaded),
    concatMap(([action, state]) => {
      const rlApprovedNotification = state.notifications.items.find(
        (n) => n.templateName === 'release-accepted' && n.status === 'unread'
      );

      if (!rlApprovedNotification) {
        return [new NoOp()];
      }
      const approvedRelease = state.catalog.releases.items.find((i) =>
        (
          rlApprovedNotification.payload as ReleaseAcceptedPayload
        ).avatar.includes(i.cover_url || '')
      );

      if (
        action.payload.location.pathname.startsWith('/dashboard') &&
        !state.ui.menuOpened &&
        approvedRelease
      ) {
        return [
          new SetPopupNotification(approvedRelease),
          new OpenMenu('RELEASE_APPROVED_MENU'),
          new ClearNotifications(rlApprovedNotification.id),
        ];
      }

      return [new NoOp()];
    })
  );
